import React from 'react'

const ArrowBackIcon = ({ width = 20, height = 16, color = '#0C172C' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.57958 0.725589C8.88961 1.01621 8.88961 1.49991 8.57958 1.78986L2.76423 7.24126L19.1971 7.24668C19.6444 7.24736 20 7.58066 20 8C20 8.41934 19.6444 8.76348 19.1971 8.76348L2.76423 8.75806L8.57958 14.1993C8.88961 14.5001 8.88961 14.9845 8.57958 15.2744C8.25872 15.5752 7.74201 15.5752 7.4327 15.2744L0.24065 8.53247C-0.0802174 8.24185 -0.0802174 7.75815 0.24065 7.4682L7.4327 0.725589C7.74273 0.424804 8.25872 0.424804 8.57958 0.725589Z"
        fill={color}
      />
    </svg>
  )
}

export default ArrowBackIcon
